import inputmask from 'inputmask'

const $phoneMask = document.querySelectorAll('.js-phone-mask');

if ($phoneMask.length > 0) {
	Array.from($phoneMask).forEach(($input) => {
		inputmask({
			mask: '+7 (999) 999-99-99',
			showMaskOnHover: false
		}).mask($input);
	});
}

const $emailMask = document.querySelectorAll('.js-email-mask');

if ($emailMask.length > 0) {
	Array.from($emailMask).forEach(($input) => {
		inputmask({
			mask: '*{1,50}[.*{1,50}][.*{1,50}]@*{1,50}.*{1,20}[.*{1,20}][.*{1,20}]',
			greedy: false,
			clearIncomplete: true,
			showMaskOnHover: false,
			definitions: {
				'*': {
					validator: '[^_@.]'
				}
			}
		}).mask($input);
	});
}

